import http from '@/http';

export default class HelperService {
  static getKits(payload) {
    return http.post('get-kits', payload);
  }
}
